import { render } from "./index.vue?vue&type=template&id=295d36c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=295d36c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295d36c2"],['__file',"src/components/UserAvatarBadge/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "295d36c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('295d36c2', __exports__)) {
    api.reload('295d36c2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=295d36c2&scoped=true", () => {
    api.rerender('295d36c2', render)
  })

}


export default __exports__